import firebase from '@/firebase/index';

export const menuMixing={
    data() {
        return {
            numCategorie:3,
            menuListes:[],
            loading:true,
            numItems:3,
            categorieLoading:false,
            activeMenu:'',
            buttonsMenu:[],
            select:0
        }
    },
    methods: {
        getMenuData(value){
            this.numItems=3;
             if(this.activeMenu==value){
               return;
             }
             this.loading=true;
             this.activeMenu=value;
             this.menuListes=[];
          const db=firebase.firestore();
          const storage = firebase.storage();
          db.collection('menu').where('categorie','==',value).get()
          .then((snapshot)=>{
            this.numItems=snapshot.docs.length;
         snapshot.forEach(doc=>{
          storage.ref(doc.data().img).getDownloadURL()
            .then((url) => {
             this.menuListes.push({
                 id:doc.id,
                 img:url,
                 description:doc.data().description,
                 price:doc.data().price,
                 discount:doc.data().discount,
                 ar:doc.data().ar,
                 en:doc.data().en,
                 fr:doc.data().fr
               });
               this.loading=false;
            })
           .catch(error=>{
             console.log(error)
           })
         })
       })
      },
      getMenuCategories(){
        this.categorieLoading=true;
        const db=firebase.firestore();
        db.collection('menuCategories').get()
         .then(snapshot=>{
           this.numCategorie=snapshot.docs.length;
           snapshot.forEach(doc=>{
             this.buttonsMenu.push({
               id:doc.id,
               en:doc.data().en,
               fr:doc.data().fr,
               ar:doc.data().ar
             })
           })
           this.getMenuData(this.buttonsMenu[0].id);
           this.activeMenu=this.buttonsMenu[0].id;
           this.categorieLoading=false;
         })
         .catch(error=>{
          console.log(error)
        })
      }
    },
    beforeMount(){
      this.getMenuCategories();
      //this.buttonsMenu=this.$store.getters.getMainMenu;
    }
}

export const validateRules={
  data() {
    return {
            loadingBtn:false,
            showPassword:false,
            userPass:{
              old:'',
              new:'',
              confirm:''
             },
            rules: {
                 required : value => !!value || this.$t('formes.errors.required'),
                 counter:value => (value && value.length >= 6) || this.$t('formes.errors.length'),
                 email:value => {
                   const pattern=/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:[A-Z]{2}|com|org|net|gov|mil|biz|info|mobi|name|aero|jobs|museum)\b/;
                   return pattern.test(value) || this.$t('formes.errors.emailRegex');
                 },
                 passwordConfirm:value =>value && this.userPass.new == this.userPass.confirm || this.$t('formes.errors.confirmPass'),
                 newPassword:value => value && this.userPass.old!=this.userPass.new || this.$t('formes.errors.newPass')
            },
            errorMessages:{
                email:{
                  show:false,
                  code:'none'
                },
                password:{
                  show:false,
                  code:'none'
                }
              }
    }
  },
  methods: {
    resetEmailError(){
      this.errorMessages.email.show=false;
      this.errorMessages.email.code='none';
    },
    resetPasswordError(){
      this.errorMessages.password.show=false;
      this.errorMessages.password.code='none';
    }
  },
}

export const lang={
  computed: {
    lang(){
      return this.$i18n.locale;
  }
  },
  methods: {
    getName(data,name){
      return data[this.lang][name] ?data[this.lang][name] :data[name]
    }
  },
}

export const userAvatar={
  data() {
    return {
      imgSrc:''
    }
  },
  methods: {
    getuserAvatar(photoUrl,provid){
      if(provid!='firebase'){
        this.imgSrc= photoUrl;
      }else{
      const storage=firebase.storage();
       storage.ref('users').child(photoUrl).getDownloadURL()
        .then((url) => {
          console.log(url)
          this.imgSrc= url;
        })
        .catch(error=>{
          console.log(error)
        })
      }
    }
  },
}